import React from 'react';
import {
  Link_out, Service_not_have_screens,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';

//= ========================================================================
const Panel_I01_LinkOut = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <FullPagePanel
    globJSON={globJSON}
    onConfigChanged={onConfigChanged}
    selectedScreen={selectedScreen}
    onStepPressed={onStepPressed}
    onGotoEdit={onGotoEdit}
    panelHeadline={Link_out}
    paragraph={Service_not_have_screens}
    language={language}
    hideStepIndicator
    disableEditElements
  />
);

export default Panel_I01_LinkOut;
